import React from 'react';
import { Phone, PhoneOff } from 'lucide-react';

const formatDuration = (seconds) => {
  const mins = Math.floor(seconds / 60);
  const secs = seconds % 60;
  return `${mins}:${secs.toString().padStart(2, '0')}`;
};

/**
 * Compact pill shown when the dialer is collapsed during an active call.
 * Click anywhere to expand. Hang-up button on the right.
 */
export const MinimizedDialerView = ({ callState, callDuration, callerNumber, audioRef, onExpand, onHangup }) => {
  const dotClass =
    callState === 'connected' ? 'bg-green-500 animate-pulse' :
    callState === 'on_hold' ? 'bg-yellow-500' : 'bg-teal-400';

  return (
    <div
      className="fixed bottom-4 right-4 bg-[#0d1117] border border-gray-700 rounded-xl p-3 shadow-2xl z-50 cursor-pointer"
      onClick={onExpand}
      data-testid="dialer-minimized-view"
    >
      <div className="flex items-center gap-3">
        <div className={`w-10 h-10 rounded-full flex items-center justify-center ${dotClass}`}>
          <Phone className="w-5 h-5 text-white" />
        </div>
        <div>
          <p className="text-white text-sm font-medium">{callerNumber || 'Call'}</p>
          <p className="text-gray-400 text-xs">{formatDuration(callDuration)}</p>
        </div>
        <button
          onClick={(e) => { e.stopPropagation(); onHangup(); }}
          className="ml-2 p-2 bg-red-500 hover:bg-red-600 rounded-full"
          data-testid="dialer-minimized-hangup-btn"
        >
          <PhoneOff className="w-4 h-4 text-white" />
        </button>
      </div>
      {/* Hidden audio element for remote stream */}
      <audio ref={audioRef} autoPlay />
    </div>
  );
};
